export default __webpack_public_path__ + "static/media/icon_dot.a090b3be.svg";